import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconWifi = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconWifi",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-120q-42 0-71-29t-29-71 29-71 71-29 71 29 29 71-29 71-71 29m0-440q75 0 143 24t122 66q20 15 21 40t-18 42q-17 17-42 18t-45-14q-38-26-84-41t-97-15-97 15-84 41q-20 14-45 13t-42-18q-17-18-17-42t20-40q55-42 123-65t142-24m0-240q125 0 236 41t198 116q20 17 21 42t-17 43q-17 17-42 18t-45-16q-72-59-161-91t-190-33-189 33-162 91q-20 16-45 16t-42-18q-18-18-17-43t21-42q88-75 199-116t235-41"
  })
}));